import { IkeUnit } from '@ikegps/core-shared';
import { T } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import { addStyles } from '../theme';
import { DistanceInputState } from './distance.input.state';
import { CSS, Style } from './distance.input.style';
import { Input } from './input';
import { NumberInputState } from './number.input.state';
import { Unit } from './unit';

addStyles(Style);

export const DistanceInput = {
	view(state: DistanceInputState, unit: IkeUnit = Services.UserSettings.units): MithrilVNode {
		let children: MithrilVNode[];
		if (unit === IkeUnit.METER) {
			children = DistanceInput.viewMetric(state.meters);
		} else {
			children = DistanceInput.viewImperial(state.feet, state.inch);
		}

		return m('div', { className: CSS.container }, children);
	},

	viewMetric(state: NumberInputState): MithrilVNode[] {
		return [Input.view(state), Unit.view(T.UNIT_SHORT_METER)];
	},

	viewImperial(feetState: NumberInputState, inchState: NumberInputState): MithrilVNode[] {
		return [Input.view(feetState), Unit.view(T.UNIT_SHORT_FEET), Input.view(inchState), Unit.view(T.UNIT_SHORT_INCH)];
	},
};
